import ExpressLogo from "@/assets/Express-png.png";
import GraphQlLogo from "@/assets/GraphqlPng.png";
import NestJsLogo from "@/assets/NestJsPng.png";
import NextJsLogo from "@/assets/NextJsPng.png";
import PostGresLogo from "@/assets/PostGresPng.png";
import PythonLogo from "@/assets/PythonPng.png";
import ReactLogo from "@/assets/ReactPng.png";
import RemixJsLogo from "@/assets/RemixjsPng.png";
import { motion } from "framer-motion";
import { MotionDiv } from "../animations/MotionDivWrapper";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";

const Logos = [
  {
    logo: ReactLogo,
    description: "A JavaScript library for building user interfaces",
  },
  {
    logo: NextJsLogo,
    description: "The React framework for production-grade web apps",
  },
  {
    logo: RemixJsLogo,
    description: "A full stack framework focused on fast, resilient UX",
  },
  {
    logo: ExpressLogo,
    description: "A minimalist Node.js framework for building APIs",
  },
  {
    logo: NestJsLogo,
    description: "A progressive Node.js framework for scalable servers",
  },
  {
    logo: GraphQlLogo,
    description: "A query language for APIs and runtime for fetching data",
  },
  {
    logo: PostGresLogo,
    description: "A powerful, open-source relational database system",
  },
  {
    logo: PythonLogo,
    description: "A versatile programming language for backend and AI",
  },
];

const Tech = () => {
  return (
    <div className="container w-full mx-auto mt-14 lg:mt-40" id="tech">
      <MotionDiv direction="up" delay={0.4}>
        <h2 className="text-center text-4xl uppercase">Technologies</h2>
      </MotionDiv>
      <MotionDiv direction="up" delay={0.6}>
        <p className="text-md lg:text-xl text-[#8A8F98] mt-4 text-center">
          Tools and frameworks I work with to build modern, scalable
          applications.
        </p>
      </MotionDiv>
      {/* for large screens */}
      <MotionDiv delay={0.6}>
        <div className="mt-10 mx-auto w-full hidden lg:flex flex-wrap">
          {Logos.map((logo, index) => (
            <MotionDiv
              key={index}
              delay={0.8 + index * 0.1}
              direction="up"
              transition={{
                duration: 0.5,
              }}
              className="basis-1/2 sm:basis-1/3 md:basis-1/4 py-6 flex justify-center relative"
            >
              <Tooltip>
                <TooltipTrigger asChild>
                  <motion.img
                    src={logo.logo}
                    alt={logo.description}
                    className="w-14 h-14 object-contain group"
                    whileHover={{
                      scale: 1.15,
                      filter:
                        "drop-shadow(0px 0px 10px rgba(255,255,255,0.25))",
                    }}
                    transition={{ type: "spring", stiffness: 300, damping: 15 }}
                  />
                </TooltipTrigger>
                <TooltipContent className="w-40 border border-[#8A8F98] p-2 rounded-md">
                  <p className="text-sm text-[#8A8F98]">{logo.description}</p>
                </TooltipContent>
              </Tooltip>
            </MotionDiv>
          ))}
        </div>
      </MotionDiv>

      {/* for small screens */}
      <div className="lg:hidden overflow-hidden w-full relative mt-10">
        <motion.div
          className="flex gap-6 whitespace-nowrap min-w-[200%]"
          animate={{ x: ["0%", "-100%"] }}
          transition={{
            repeat: Infinity,
            repeatType: "loop",
            duration: 20,
            ease: "linear",
          }}
        >
          {[...Logos, ...Logos].map((logo, index) => (
            <div key={index} className="inline-block relative flex-none">
              <img
                src={logo.logo}
                alt={logo.description}
                className="w-8 h-8 object-contain cursor-pointer flex-none"
              />
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default Tech;
